import {Box, Button} from "@mui/material";
import React, {useEffect, useState} from "react";
import {styled} from "@mui/material/styles";
import {ILocale} from "../../services/localize.service";
import {useAppDispatch} from "../../hooks/redux";
import {changeLanguageApp} from "../../store/actions/userAction";
import {useGlobalContext} from "../../services/context.service";
import {IConfig, ILanguage} from "../../utils/interface";
import {getConfigFromFile} from "../../utils/methods";

const WrapperStyle = styled(Box)(() => ({
    display: "flex", color: "#ccc"
}));

const ButtonLanguage = styled(Button)(() => ({
    padding: 0
}));

interface IChangeLanguage {
    sx: React.CSSProperties;
}

export default function ChangeLanguage({sx}: IChangeLanguage) {
    const {locale} = useGlobalContext();
    const [language, setLanguage] = useState<ILocale>('uk');
    const [languageList, setLanguageList] = useState<ILanguage[]>([
        {
            "langISO": "uk",
            "label": "UA"
        },
        {
            "langISO": "en",
            "label": "EN"
        },
        {
            "langISO": "ru",
            "label": "RU"
        }
    ]);
    const dispatch = useAppDispatch();

    const getConfig = async () => {
        const {config: {locale: {language}}}: IConfig = await getConfigFromFile();
        language && setLanguageList(language);
    };

    useEffect(() => {
        getConfig().then();
        setLanguage(locale);
    }, [])

    const handleChange = (lang: ILocale) => {
        dispatch(changeLanguageApp(lang));
        setLanguage(lang);
    };

    return (<WrapperStyle sx={{...sx}}>
        {languageList.map((languageItem, idx) => (<Box key={languageItem.langISO}><ButtonLanguage variant={'text'}
                                                                    style={{color: language === languageItem.langISO ? "inherit" : "#626262"}}
                                                                    onClick={handleChange.bind(null, languageItem.langISO)}
        >{languageItem.label}</ButtonLanguage>
            {idx + 1 !== languageList.length ? "|" : ""}
        </Box>))}
    </WrapperStyle>)
    /*
        return (<WrapperStyle>
            <FormControl variant="standard" size="small" fullWidth sx={{ minWidth: 100}}>
                <Select
                    value={language}
                    onChange={handleChange}
                    sx={{textAlign: 'center'}}
                >
                    <MenuItem value={'uk'}>Українська</MenuItem>
                    <MenuItem value={'ru'}>Русский</MenuItem>
                    <MenuItem value={'en'}>English</MenuItem>
                </Select>
            </FormControl>
        </WrapperStyle>)

     */
}
